module.exports = "/_next/static/images/virtual-card-green-1c8bb7d20600067bc91719b3689f12ca.svg";